import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { translate } from 'react-i18next'
import styled from 'styled-components'

import { editProjectQuestions } from '../../actions'

import { Form, Button, Input, Icon } from 'antd'
const FormItem = Form.Item

const uuid = require('uuid/v1')
const labelWidth = 1
const wrapperWidth = 23

const iconButtonStyle = {
  padding: '8px 3px',
  margin: '0 5px',
  cursor: 'pointer'
}

const QuestionsWrapper = styled.div`
  .question-text.first .anticon-arrow-up,
  .question-text.last .anticon-arrow-down {
    visibility: hidden
  }
`

class ProjectSettingsQuestions extends Component {
  constructor (props) {
    super(props)
    // create a ref to store the newAnswerInput DOM element
    this.newAnswerInput = React.createRef()
  }

  state = {
    originalQuestions: this.props.project.questions,
    newQuestions: this.props.project.questions,
    newQuestionInputVisible: false,
    newQuestionValue: ''
  }

  handleSubmit = e => {
    e.preventDefault()
    const { form, project, editProjectQuestions } = this.props
    const { newQuestions } = this.state

    form.validateFields((err, values) => {
      if (!err) {
        // TODO: ordering in 'values.questions' and 'newQuestions' is different
        // at this point on second save, why? have to use local state 'newQuestions' in edit action
        // console.log('handleSubmit-values', values.questions)
        // console.log('handleSubmit-state', newQuestions)

        editProjectQuestions(project.id, newQuestions, this.updateQuestionsState)
      }
    })
  }

  // this method is passed to 'editProjectQuestions' action
  updateQuestionsState = questions => {
    this.setState({
      originalQuestions: questions,
      newQuestions: questions
    })
  }

  onQuestionTextChange = (questionId, text) => {
    this.setState({
      newQuestions: {
        ...this.state.newQuestions,
        [questionId]: {
          ...this.state.newQuestions[questionId],
          text
        }
      }
    })
  }

  addQuestion = () => {
    const text = this.newAnswerInput.current.value
    const newQuestionId = uuid()

    this.setState({
      newQuestions: {
        ...this.state.newQuestions,
        [newQuestionId]: {
          id: newQuestionId,
          order: _.size(this.state.newQuestions) + 1,
          text
        }
      }
    })

    this.handleNewQuestionInputVisibility()
  }

  removeQuestion = questionId => {
    const newQuestions = { ...this.state.newQuestions }
    const questionOrder = newQuestions[questionId].order

    delete newQuestions[questionId]

    // update question orders
    _.forEach(newQuestions, (question, questionId2) => {
      if (question.order > questionOrder) {
        newQuestions[questionId2].order = newQuestions[questionId2].order - 1
      }
    })

    this.setState({
      newQuestions
    })
  }

  moveQuestion = (questionId, direction) => {
    const newQuestions = { ...this.state.newQuestions }
    const selectedQuestionOrder = newQuestions[questionId].order

    if (direction === 'up') {
      const previousQuestion = _.find(newQuestions, { order: selectedQuestionOrder - 1 })
      newQuestions[previousQuestion.id].order = selectedQuestionOrder
      newQuestions[questionId].order = selectedQuestionOrder - 1
    } else {
      const nextQuestion = _.find(newQuestions, { order: selectedQuestionOrder + 1 })
      newQuestions[nextQuestion.id].order = selectedQuestionOrder
      newQuestions[questionId].order = selectedQuestionOrder + 1
    }

    this.setState({
      newQuestions
    })
  }

  handleNewQuestionInputVisibility = () => {
    this.setState({
      newQuestionInputVisible: !this.state.newQuestionInputVisible
    })
  }

  handleNewQuestionInputChange = e => {
    this.setState({ newQuestionValue: e.target.value })
  }

  newQuestionInputKeyPress = e => {
    if (e.keyCode === 13 && e.target.value) {
      this.addQuestion(e.target.value)
    }
  }

  addQuestionButtonClick = () => {
    const { newQuestionValue } = this.state

    if (newQuestionValue.length) {
      this.addQuestion(newQuestionValue)
    }
  }

  addQuestion = text => {
    const newQuestionId = uuid()

    this.setState({
      newQuestions: {
        ...this.state.newQuestions,
        [newQuestionId]: {
          id: newQuestionId,
          order: _.size(this.state.newQuestions) + 1,
          text
        }
      },
      newQuestionValue: ''
      // newQuestionInputVisible: false
    })
  }

  render () {
    const { form: { getFieldDecorator }, loading } = this.props
    const { /* originalQuestions, */ newQuestions, newQuestionInputVisible } = this.state

    // 'this.props.project.questions' - redux data is also changed in 'moveQuestion', why?
    // console.log(this.props.project.questions, originalQuestions, newQuestions)

    return (
      <QuestionsWrapper>

        <div style={{ background: '#f8f8f8', padding: 15, marginBottom: 20 }}>
          {newQuestionInputVisible
            ? <Input
              value={this.state.newQuestionValue}
              placeholder='Specify new question'
              onKeyDown={this.newQuestionInputKeyPress}
              onChange={this.handleNewQuestionInputChange}
              addonAfter={
                <Icon type='plus' onClick={() => this.addQuestionButtonClick()} style={{ ...iconButtonStyle }} />
                }
              />
            : <Button icon='plus' onClick={() => this.handleNewQuestionInputVisibility()}>New question</Button>}
        </div>

        <Form onSubmit={this.handleSubmit}>

          {_.orderBy(newQuestions, 'order', 'asc').map(question => [
            // id, order helper fields - invisible
            <FormItem key={question.id + '_id'} style={{ display: 'none', width: '50%' }}>
              {getFieldDecorator(`questions.${question.id}.id`, {
                initialValue: question.id,
                rules: [{ required: true }]
              })(<Input disabled />)}
            </FormItem>,
            <FormItem key={question.id + '_order'} style={{ display: 'none', width: '50%' }}>
              {getFieldDecorator(`questions.${question.id}.order`, {
                initialValue: question.order,
                rules: [{ required: true }]
              })(<Input disabled />)}
            </FormItem>,

            // question text input
            <FormItem
              // label={question.order.toString()}
              key={question.id + '_text'}
              className={`question-text ${question.order === 1 ? 'first' : ''} ${question.order === _.size(newQuestions) ? 'last' : ''}`}
              labelCol={{ span: labelWidth }}
              wrapperCol={{ span: wrapperWidth }}
            >
              {getFieldDecorator(`questions.${question.id}.text`, {
                initialValue: question.text,
                rules: [{ required: true, message: 'Question text is required' }],
                onChange: e => this.onQuestionTextChange(question.id, e.target.value)
              })(
                <Input
                  type='textarea'
                  addonBefore={question.order.toString()}
                  addonAfter={[
                    <Icon
                      key='up'
                      type='arrow-up'
                      style={{ ...iconButtonStyle }}
                      onClick={() => this.moveQuestion(question.id, 'up')}
                    />,
                    <Icon
                      key='down'
                      type='arrow-down'
                      style={{ ...iconButtonStyle }}
                      onClick={() => this.moveQuestion(question.id, 'down')}
                    />,
                    <Icon
                      key='delete'
                      type='delete'
                      style={{ ...iconButtonStyle, color: 'red' }}
                      onClick={() => this.removeQuestion(question.id)}
                    />
                  ]}
                />
              )}

            </FormItem>
          ])}

          <Button htmlType='submit' type='primary' loading={loading.editProjectQuestions}>Save</Button>
          {/* if user changed something in the form fields, show Save button - doesn't work with reordering */}
          {/* {JSON.stringify(originalQuestions) !== JSON.stringify(newQuestions) && <div>something changed</div>} */}

        </Form>
      </QuestionsWrapper>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  nav: state.nav,
  loading: state.loading
})

const mapDispatchToParams = {
  editProjectQuestions
}

export default connect(mapStateToProps, mapDispatchToParams)(
  Form.create()(translate('translations')(ProjectSettingsQuestions))
)



// WEBPACK FOOTER //
// ./src/components/ProjectSettings/ProjectSettingsQuestions.js